// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"41a3610d","3331":"faa29f1d","6184":"41a3610d","6852":"41a3610d","8408":"7dec564c"}[chunkId] + ".chunk.css";
};